exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-news-template-tsx": () => import("./../../../src/templates/NewsTemplate.tsx" /* webpackChunkName: "component---src-templates-news-template-tsx" */),
  "component---src-templates-standardtemplate-tsx": () => import("./../../../src/templates/Standardtemplate.tsx" /* webpackChunkName: "component---src-templates-standardtemplate-tsx" */)
}

